module.exports = __webpack_public_path__ + "static/media/reformer6.1e9228fa.jpg";